import { extend } from 'lodash'
import Cookies from 'js-cookie'
import extract from '~/tools/extractDomain'

var storedUser = window.localStorage.getItem('user')
var initialState = (storedUser && JSON.parse(storedUser)) || {}




export default function reducer(state=initialState, action={}) {
  var pl = action.payload

  var extention =
    action.type === 'LOGIN_FULFILLED' ? { user: pl } :
    action.type === 'SIGNUP_FULFILLED' ? { user: pl } :
    action.type === 'USER_CARD_DETAILS' ? {user: pl} :
    action.type === 'LOGOUT_FULFILLED' ? { user: null } :
    action.type === 'UPDATE_FULFILLED' ? {
      user: {...state.user,
        email: pl.data.email,
        name: pl.data.name
      }
    } :
    action.type === 'UPDATE_CARD_FULFILLED' ? {
      user: Object.keys(pl).length > 0 ? {...state.user, billingInfo:{stripeToken: { card: pl }}} : {...state.user}
    }:
    action.type === 'REFRESH_FULFILLED' ? {
      user: {...state.user,
        email: pl.data.email,
        name: pl.data.name,
        country: pl.data.country,
        registeredOn: pl.data.registeredOn,
        registerdVia: pl.data.registerdVia,
        isSubscribed: pl.data.isSubscribed
      }
    } :
    action.type === 'GET_SUBSCRIPTION_FULFILLED' ? {
      user: {...state.user,
        subscription: action.payload,
        isSubscribed: !(
          action.payload.subscriptionInfo.subscriptionStatus === 'CANCELLED' || 
          action.payload.subscriptionInfo.subscriptionStatus === 'SUSPENDED'
        ) 
      } } :
    action.type === 'CREATE_SUBSCRIPTION_FULFILLED' ?  {
      user: {...state.user,
        isSubscribed: true
      }
    } :
    action.type === 'CREATE_TRANSACTION' ? {
      user: {
        ...state.user,
        purchasedVideoIds: (state.user.purchasedVideoIds || []).push(pl.contentRequest.contentId)
      }
    }:
    null
    
  if (extention)
    state = extend({}, state, extention)
  
  Cookies.set('vl-user', state.user && state.user.userId)  
  window.localStorage.setItem('user', JSON.stringify(state))
  return state
}
